// @flow
/** @jsx jsx */

import { jsx, css, ClassNames } from '@emotion/core';
import { Field } from 'formik';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';

import Loading from './Loading';

type Props = {
  name: string,
  label?: string,
  placeholder?: string,
  type?: string,
  className?: string,
  errors?: {
    [name: string]: string,
  },
  touched?: {
    [name: string]: string,
  },
  fieldProps?: any,
  isValidating?: boolean,
  disabled?: boolean,
};

const classField = css`
  position: relative;
`;

const InputField = (props: Props) => {
  const typeProps =
    props.type === 'textarea'
      ? {
          component: 'textarea',
        }
      : {
          type: props.type,
        };

  return (
    <FormGroup
      css={[classField, props.className]}>
      {props.label && (
        <ControlLabel htmlFor={props.name}>{props.label}</ControlLabel>
      )}
      {props.isValidating && (
        <Loading
          css={{
            position: 'absolute',
            right: '30px',
            top: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '28px',
            height: '45px',
          }}
          size="small"
          blocking={false}
        />
      )}

      <ClassNames>
        {({ css, cx }) => {
          return (
            <Field
              name={props.name}
              placeholder={props.placeholder}
              {...typeProps}
              {...props.fieldProps}
              className={cx('form-control', {
                // $FlowFixMe
                [props.className]: props.className
              })}
            />
          )
        }}
      </ClassNames>

      {props.name &&
        // $FlowFixMe
        props.errors[props.name] &&
        // $FlowFixMe
        props.touched[props.name] && (
          <HelpBlock
            css={{
              position: 'absolute',
              bottom: '-30px',
            }}
          >
            {props.errors[props.name]}
          </HelpBlock>
        )}
    </FormGroup>
  );
};

InputField.defaultProps = {
  placeholder: '',
  type: 'text',
  className: '',
  errors: {},
  touched: {},
};

export default InputField;
